"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function MenuItems(props) {
    var toggle = props.toggle, handlePreview = props.handlePreview, handleEmailPreview = props.handleEmailPreview, handleDownload = props.handleDownload, handleArchive = props.handleArchive, handleUnarchive = props.handleUnarchive, isArchived = props.isArchived, fileId = props.fileId;
    var handleDownloadClick = function () {
        toggle(false);
        handleDownload();
    };
    var handleArchiveClick = function () {
        toggle(false);
        handleArchive();
    };
    var handleUnarchiveClick = function () {
        toggle(false);
        handleUnarchive();
    };
    var handlePreviewClick = function () {
        toggle(false);
        if (handleEmailPreview)
            handleEmailPreview(fileId);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        if (!handleEmailPreview)
            handlePreview(true);
    };
    var menuItems = [
        {
            label: 'Preview',
            onClick: handlePreviewClick,
            target: '_blank',
        },
        {
            label: 'Download',
            onClick: handleDownloadClick,
        },
        {
            label: 'View Details',
            onClick: function () { return toggle(false); },
            href: "/files-app/files/".concat(fileId),
            target: '_blank',
        },
    ];
    if (isArchived) {
        menuItems.push({
            label: 'Unarchive',
            onClick: handleUnarchiveClick,
        });
    }
    else {
        menuItems.push({
            label: 'Archive',
            onClick: handleArchiveClick,
        });
    }
    return react_1.default.createElement(core_ui_1.Menu, { items: menuItems });
}
exports.default = MenuItems;
